import { render, staticRenderFns } from "./HistoricCompanies.vue?vue&type=template&id=14b921da&scoped=true"
import script from "./HistoricCompanies.vue?vue&type=script&lang=js"
export * from "./HistoricCompanies.vue?vue&type=script&lang=js"
import style0 from "./HistoricCompanies.vue?vue&type=style&index=0&id=14b921da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b921da",
  null
  
)

export default component.exports